<div class="container-fluid">
  <div class="row">
    
    <div class="col-12 mb-2">
      <div class="row">

        <div class="col-6 text-secondary">
          <small>Nada probable</small>
        </div>

        <div class="col-6 text-end text-secondary">
          <small>Muy probable</small>
        </div>

      </div>
    </div>

    <div class="col-12">
      <div class="row">

        @for (i of range; track i) {
          <div class="col text-center px-1">
            <a 
              class="py-2 text-decoration-none d-block cursor-pointer"
              (click)="onScaleChange(i)"
              [ngClass]="{
                'bg-danger text-white': scaleValue === i && i < 7,
                'bg-warning text-black': scaleValue === i && i > 6 && i < 9,
                'bg-success text-white': scaleValue === i && i > 8,
                'bg-secondary text-primary fw-600': scaleValue !== i
              }">
              {{ i }}
            </a>
          </div>
        }

      </div>

      @if(pregunta) {

        @for(rango of pregunta.rangos; track $index) {

          @if(scaleValue != null) {
            @if(
              scaleValue >= rango.valorMinimo && 
              scaleValue <= rango.valorMaximo
            ) {

              @for(preguntaRango of rango.preguntas; track $index) {

                <div class="row mt-5">

                  <app-pregunta-item
                    [pregunta]="preguntaRango">
                  </app-pregunta-item>

                </div>

              }

            }
          }

        }

      } 

    </div>

  </div>
</div>